import React from "react";

// Jenburkt wordmark with CBC pill + ZIXA subline
export function JenburktBrand({ compact = false, light = false }) {
  return (
    <div className="flex items-center gap-3">
      <div className={`rounded-md flex items-center justify-center overflow-hidden ${light ? "bg-white" : "bg-white border border-slate-200"} ${compact ? "h-10 w-12 p-1" : "h-12 w-14 p-1"}`}>
        <img src="/brand/jenburkt.png" alt="Jenburkt" className="h-full w-full object-contain" />
      </div>
      <div className="leading-tight">
        <div className={`${compact ? "text-[13px]" : "text-[15px]"} font-semibold ${light ? "text-white" : "text-slate-900"} tracking-tight`}>
          Jenburkt <span className="opacity-70 font-normal">Pharmaceuticals</span>
        </div>
        <div className="flex items-center gap-2 mt-0.5">
          <span className={`small-caps ${light ? "text-teal-300" : "text-teal-700"}`}>CBC · Champion Behind the Champions</span>
          {!compact && <span className="tag tag-teal !text-[10px] !py-[1px]" data-testid="brand-zixa-tag">ZIXA Strong</span>}
        </div>
      </div>
    </div>
  );
}

// ChannelLoyalty.ai mark (small, used in footer / login)
export function CLAIMark({ tone = "slate" }) {
  const color = tone === "light" ? "text-slate-300" : "text-slate-500";
  return (
    <div className={`flex items-center gap-2 ${color}`}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M3 12a9 9 0 1 1 18 0M3 12h18M12 3v18" />
      </svg>
      <span className="small-caps">Powered by <span className="font-semibold">ChannelLoyalty.ai</span></span>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white px-6 py-3 flex items-center justify-between text-[11px] text-slate-500">
      <div>
        © {new Date().getFullYear()} Jenburkt Pharmaceuticals Ltd. · CBC Program · ZIXA Strong · Delivering Excellence in Life Sciences
      </div>
      <CLAIMark />
    </footer>
  );
}
